// @flow

const parseDate = (str: null | string, sep: string = '_'): null | Date => {
  if (!str) {
    return null;
  }
  const fields = str.split(sep);
  if (fields.length !== 3) {
    return null;
  }
  const year = parseInt(fields[0], 10);
  const month = parseInt(fields[1], 10);
  const day = parseInt(fields[2], 10);
  if (!year || !month || month < 1 || month > 12 || !day || day < 1 || day > 31) {
    return null;
  }
  return new Date(year, month - 1, day);
};

const zeroPad = n => (n < 10 ? `0${n}` : n);

const serializeDate = (date: null | Date, sep: string = '_'): string =>
  date === null
    ? ''
    : `${date.getFullYear()}${sep}${zeroPad(date.getMonth() + 1)}${sep}${zeroPad(date.getDate())}`;

const parseStayDates = (
  stayDates: string,
): null | {| +checkInDate: null | Date, +checkOutDate: null | Date |} => {
  const tokens = stayDates.split('_');
  if (tokens.length !== 6) {
    return null;
  }
  return {
    checkInDate: parseDate(tokens.slice(0, 3).join('_')),
    checkOutDate: parseDate(tokens.slice(3).join('_')),
  };
};

const parseGuestInfo = (
  guests: string,
): {|
  +rooms: number,
  +adults: number,
  +children: number,
  +childAgesPerRoom: number[][],
|} | null => {
  const guestInfoSegments = guests.split('_');
  if (guestInfoSegments.length === 1) {
    return null;
  }
  const childAgesPerRoom =
    guestInfoSegments.length > 2
      ? guestInfoSegments[2].split(':').map(room => room.split(',').map(age => parseInt(age, 10)))
      : [];
  const children = childAgesPerRoom.reduce((accum, room) => accum + room.length, 0);

  return {
    rooms: parseInt(guestInfoSegments[0], 10),
    adults: parseInt(guestInfoSegments[1], 10),
    children,
    childAgesPerRoom,
  };
};

export { parseDate, serializeDate, parseGuestInfo, parseStayDates };
